import withModal from '../../../../../../components/global/modal/withModal';
import PhotoAlbumFolderTagsContainer from './PhotoAlbumFolderTagsContainer';
import { PHOTO_ALBUM_FOLDER_TAGS } from '../../../../../../constants/modals';

export default withModal(PhotoAlbumFolderTagsContainer, {
  name: PHOTO_ALBUM_FOLDER_TAGS,
  contentLabel: 'Manage tags for this photo',
  size: 'sm',
});
